define('modules/editor/views/correodirect_popup',['require','exports','module','common/views/modal_layout','./correodirect_forms','ldsh!../templates/correodirect_popup'],function (require, exports, module) {
  'use strict';

  var ModalLayout = require('common/views/modal_layout'),
    FormsView = require('./correodirect_forms');

  module.exports = ModalLayout.extend({
    template: require('ldsh!../templates/correodirect_popup'),
    regions: {
      forms: '#js-forms-region',
    },
    events: {
      'click .js-save': 'save',
      'click .js-cancel': 'hide',
    },
    initialize: function (options) {
      this.onSave = options.onSave || _.identity;
      this.collection = options.collection;
      this.regions.forms.show(
        new FormsView({
          collection: this.collection,
        })
      );
    },
    save: function () {
      var idaf = this.$('#idaf').val().trim(),
        active = this.$('#active').is(':checked');
      this.model.set('idaf', idaf);
      if (this.model.isValid() & this.collection.isValid()) {
        this.model.set('active', active);
        this.triggerMethod('save', this);
      } else {
        var errors = [].concat(this.model.validationError, this.collection.validationError);
        this.showErrors(errors);
      }
    },
    showErrors: function (errors) {
      _.each(
        errors,
        function (err) {
          if (!err) return;
          this.$('#' + err.attribute)
            .parent()
            .addClass('has-error');
          this.$('.js-error-' + err.attribute).removeClass('hidden');
        },
        this
      );
    },
    onRender: function () {
      this.$el.i18n();
    },
  });
});

